import * as R from 'ramda';

import { resetTerms as resetJsonQueryTerms } from './helpers';
import { resetForDay } from './resetForDay';
import { FDealType, FOfferType, TJsonQuery, TJsonQueryOptionalKeys } from './types';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from './utils';
import { setOfferType } from './setOfferType';
import { isFlat } from './category';
import { setRoomTypes } from './setRoomTypes';

const IGNORED_TERMS = ['for_day', 'room'];

export function resetTerms(jsonQuery: TJsonQuery) {
  return (terms: TJsonQueryOptionalKeys[]): TJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    if (terms.includes('for_day')) {
      nextJsonQuery = resetForDay(nextJsonQuery)();
    }

    const dealType = dealTypeFromJsonQuery(jsonQuery);
    const offerType = offerTypeFromJsonQuery(jsonQuery);

    if (dealType === FDealType.Sale && isFlat(offerType)) {
      if (terms.includes('building_status')) {
        nextJsonQuery = setOfferType(nextJsonQuery)(FOfferType.Flat);
      }

      if (terms.includes('room')) {
        nextJsonQuery = setRoomTypes(nextJsonQuery)(null);
      }
    }

    const termsToReset = terms.filter(t => !IGNORED_TERMS.includes(t));

    return resetJsonQueryTerms(termsToReset)(nextJsonQuery);
  };
}
